<ng-container *ngIf="viewModel$ | async as viewModel">

  <main class="grid job-chrome jobsv2-{{ colorScheme.colorScheme.value }}">
    <div class="job-column">
      <app-job-header></app-job-header>

      <div
        *ngIf="viewModel.editDisabledWarning"
        class="p-message p-message-warn p-mb-2 edit-disabled-warning"
        role="alert"
      >
        <span class="p-message-icon pi pi-exclamation-triangle"></span>
        <div class="p-message-text">
          <ng-container [ngSwitch]="viewModel.editDisabledWarning.type">
            <span *ngSwitchCase="'above-zone'" class="warning-with-action">
              <span>{{ viewModel.editDisabledWarning.text }}</span>
              <span class="warning-buttons">
                <button
                  pButton
                  type="button"
                  class="p-button-warning p-button-outlined"
                  icon="pi pi-download"
                  label="Import"
                  (click)="
                    store.dispatch(JobToolActions.importJobButtonClicked())
                  "
                ></button>
              </span>
            </span>
            <span *ngSwitchDefault>
              {{ viewModel.editDisabledWarning.text }}
            </span>
          </ng-container>
        </div>
      </div>

      <app-karve-tabview
        [tabs]="tabsWithSlug"
        [baseUrl]="viewModel.baseUrl"
        class="job-tabs"
      ></app-karve-tabview>

      <!--
        .tab-outlet: the single <router-outlet> for ALL child routes.

        Normal mode: sits inside .job-column in document flow, styled as the tab body.
        Navigator mode (:host.navigator-active): pulled out via position:fixed; inset:0
          and z-index:2000000001 to cover the entire viewport, hiding all chrome.
      -->
      <div class="tab-outlet">
        <router-outlet></router-outlet>
      </div>
    </div>

    <app-job-activity class="job-column"></app-job-activity>

    <p-dialog
      header="New Event"
      [modal]="true"
      [visible]="viewModel.isDialogVisible"
      [closable]="false"
      [breakpoints]="{ '1024px': '62vw', '510px': '93vw' }"
      [style]="{ width: '35vw' }"
    >
      <ng-template pTemplate="headless">
        <app-timeline-create-event></app-timeline-create-event>
      </ng-template>
    </p-dialog>
  </main>

  <app-unsaved-changes-banner></app-unsaved-changes-banner>
  <app-timeline-book-event></app-timeline-book-event>

</ng-container>
